// 자석 아이템 클래스 - 디버그 로그 출력
class Magnet extends Item {
  constructor(scene, x = 0, z = 0) {
    super(scene, x, z);

    this.modelPath = ItemConfig.MAGNET.MODEL_PATH;
    this.itemManager = null; // ItemManager 참조
  }

  // ItemManager 참조 설정
  setItemManager(itemManager) {
    this.itemManager = itemManager;
  }

  // 자석 아이템 효과 적용
  applyEffect(player) {
    if (!player) return;

    // ItemManager를 통해 모든 다이아몬드에 자석 효과 적용
    if (this.itemManager) {
      const affectedCount = this.itemManager.activateMagnetForAllDiamonds();
      // Utils.log(
      //   `🧲 자석 효과로 ${affectedCount}개의 다이아몬드가 끌어당겨집니다!`
      // );
    } else {
      Utils.log(
        "⚠️ ItemManager가 설정되지 않아 자석 효과를 적용할 수 없습니다.",
        "error"
      );
    }
  }

  // 수집 효과 연출 (자석 효과로 이름 변경)
  playCollectionEffect() {
    this.playMagnetEffect();

    if (this.collectedPlayer) {
      this.applyEffect(this.collectedPlayer);
    }
  }

  // 자석 수집 효과 연출
  playMagnetEffect() {
    // 반짝임 효과나 사운드 효과를 여기에 구현
    // Utils.log("✨ 자석 효과!");
  }
}

// webpack 빌드를 위해 default export 추가
export default Magnet;

// 전역 변수로도 등록 (기존 코드 호환성)
window.Magnet = Magnet;